import { useEffect, useRef, useState } from "react";
import Input from "./input";
import t from "../locales";

export default function StartDialog({ isOpen, onClose, onSubmit }) {
  const dialogRef = useRef(null);
  const [groupCode, setGroupCode] = useState("");
  const [groupName, setGroupName] = useState("");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;

    if (isOpen && !dialog.open) {
      dialog.showModal();
    } else if (!isOpen && dialog.open) {
      dialog.close();
    }
  }, [isOpen]);

  function handleCancel(event) {
    event.preventDefault();
    onClose();
  }

  function handleChange(field, setValue) {
    return (value) => {
      setValue(value);
      setErrors((current) => ({ ...current, [field]: null }));
    };
  }

  function handleSubmit(event) {
    event.preventDefault();

    const fields = {
      groupCode: groupCode.trim(),
      groupName: groupName.trim(),
    };
    const nextErrors = {
      groupCode: fields.groupCode ? null : t("start.dialog.group-code.error"),
      groupName: fields.groupName ? null : t("start.dialog.group-name.error"),
    };

    setErrors(nextErrors);
    if (Object.values(nextErrors).some(Boolean)) return;

    onSubmit(fields);
  }

  return (
    <dialog
      ref={dialogRef}
      className="dialog"
      aria-labelledby="start-dialog-title"
      closedby="any"
      onCancel={handleCancel}
    >
      <form className="dialog__form" onSubmit={handleSubmit} noValidate>
        <div className="dialog__header">
          <h2 className="dialog__title" id="start-dialog-title">
            {t("start.dialog.title")}
          </h2>
          <p className="dialog__description">{t("start.dialog.description")}</p>
        </div>
        <Input
          id="group-code"
          label={t("start.dialog.group-code.label")}
          placeholder={t("start.dialog.group-code.placeholder")}
          value={groupCode}
          onChange={handleChange("groupCode", setGroupCode)}
          error={errors.groupCode}
          autoFocus
        />
        <Input
          id="group-name"
          label={t("start.dialog.group-name.label")}
          placeholder={t("start.dialog.group-name.placeholder")}
          value={groupName}
          onChange={handleChange("groupName", setGroupName)}
          error={errors.groupName}
        />
        <button className="button" type="submit">
          {t("start.dialog.submit")}
        </button>
      </form>
    </dialog>
  );
}
